import {connect} from 'react-redux';
import {setNavigationAnnouncement} from 'shared/actions/accessibility-announcement';
import {fetchOpportunityCard} from 'shared/micro-scholarships/actions/opportunity-cards';
import MicroscholarshipsDetail from 'shared/micro-scholarships/components/scholarships-detail';

const mapStateToProps = ({detailedOpportunityCards}) => ({
  opportunityCards: detailedOpportunityCards,
});

export default connect(mapStateToProps, {
  fetchOpportunityCard,
  setNavigationAnnouncement,
})(MicroscholarshipsDetail);
